// src/components/OAuthCallback.js

import React, { useEffect } from "react";
import LoadingScreen from "./UI/loading-screen";
import { useLocation, useNavigate } from "react-router";
import { baseUrl } from "../index";
import { useCookies } from "react-cookie";
import {
  getEnvironmentConfiguration,
  isLocalhost,
} from "../common/environments";

const OAuthCallback = () => {
  console.warn("oauthcallback");
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies([], {
    doNotParse: true,
  });
  useEffect(() => {
    console.log("OAuthCallback component mounted");
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");
    console.log("auth code", code);
    const config = getEnvironmentConfiguration();

    if (code) {
      // Call your backend API to exchange the code for an access token
      fetch(`${config.payment_base_oauth_url}/callback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Token exchange successful:", data);
          // Handle token exchange data here, for example, navigate to a new page or update state
          const { cookieValue } = data;
          if (cookieValue) {
            setCookie("allUserData", cookieValue, {
              path: "/",
              maxAge: 21600,
              sameSite: "strict",
            });
            if (isLocalhost()) {
              navigate(`/details`);
            } else {
              navigate(`/registration?redirect=F`);
            }
          }
        })
        .catch((err) => {
          console.error("Error during token exchange:", err);
        });
    } else {
      console.error("Authorization code not found in URL.");
    }
  }, [location, navigate]); // Ensure location dependency is included for useEffect

  return (
    <>
      <LoadingScreen />
    </>
  );
};

export default OAuthCallback;
